import { Loading } from "@nextui-org/react";

export function BTBLoader() {
  return (
    <div className="d-flex flex-row p-5 align-items-center justify-content-center">
      <Loading />
    </div>
  )
}